import { Component, OnInit } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { LoaderUtilService } from '@app/services/loader/loader-util.service';
import { AsyncPipe } from '@angular/common';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'b2b-ripple-loader',
  templateUrl: './ripple-loader.component.html',
  styleUrls: ['./ripple-loader.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
})
export class RippleLoaderComponent implements OnInit {
  isLoading$: Observable<boolean>;
  message$: Subject<string>;

  constructor(private loaderService: LoaderUtilService) {
    this.isLoading$ = this.loaderService.isLoading?.pipe(
      delay(250),
      tap((result) => {}),
    );
    this.message$ = this.loaderService.message;
  }

  ngOnInit(): void {}

  onClick() {
    if (this.loaderService?.configOptions?.backdrop) {
      this.loaderService.hide();
    }
  }
}
